module.exports = __webpack_public_path__ + "media/images/carrusel/gobierno-f56d0c733536a1fa459eab073f536b79.jpg";